export const GROUP_EVENT_REGISTRATION_VIEW_EVENT =
  'view-group-event-registration'

export const groupEventRegistrationEventProps = ({ groupEvent } = {}) => ({
  purchase_type: 'group_event',
  contact_phone_required: true,
  ...(groupEvent?.slug ? { group_event_slug: groupEvent.slug } : {}),
  ...(groupEvent?.id ? { group_event_id: groupEvent.id } : {}),
})
